import React from 'react';
import LoadingContent from 'components/LoadingContent';

type SavingIndicatorProps = {
  saving?: boolean;
  loading?: boolean;
  /** @deprecated Messages removed; uses shared LoadingContent spinner. */
  loadingMessage?: string;
  /** @deprecated Messages removed; uses shared LoadingContent spinner. */
  savingMessage?: string;
};

const SavingIndicator = ({
  saving = false,
  loading = false,
}: SavingIndicatorProps) => {
  if (!saving && !loading) {
    return null;
  }

  return (
    <div
      className="gm-saving-indicator"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <LoadingContent />
    </div>
  );
};

export default SavingIndicator;
